import { useEffect, useState } from "react";

export const PRICE_SWITCH_AT = new Date("2026-10-10T10:10:00+02:00").getTime();

export const FOUNDING = {
  price: 2222,
  priceLabel: "2.222 €",
  checkoutUrl: "https://checkout.luisabergholz.com/unverschaemt-founding/",
  founding: true,
};

export const REGULAR = {
  price: 3300,
  priceLabel: "3.300 €",
  checkoutUrl: "https://checkout.luisabergholz.com/unverschaemt",
  founding: false,
};

export const isFoundingPhase = () => Date.now() < PRICE_SWITCH_AT;

export const getPricing = () => (isFoundingPhase() ? FOUNDING : REGULAR);

export const usePricing = () => {
  const [founding, setFounding] = useState(isFoundingPhase);
  useEffect(() => {
    if (!founding) return;
    const ms = Math.min(PRICE_SWITCH_AT - Date.now(), 2147000000);
    const id = setTimeout(() => setFounding(isFoundingPhase()), Math.max(ms, 0) + 500);
    return () => clearTimeout(id);
  }, [founding]);
  return founding ? FOUNDING : REGULAR;
};
